<template>
    <el-input v-bind="$attrs" v-model="modelValue">
        <template #suffix>
            <el-button size="mini" round @click="handleClick">{{
                $attrs.label
            }}</el-button>
        </template>
    </el-input>
</template>

<script>
export default {
    name: "loginPhoneInput",
    data() {
        return {
            a: "我是验证码",
        };
    },
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
    },
    computed: {
        modelValue: {
            get({ value, $attrs }) {
                if ($attrs.multiple && !Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        handleClick() {
            this.$emit("getCode", this.a);
        },
    },
};
</script>

<style lang="scss" scoped>
.el-button {
    color: var(--main-color);

    &:hover {
        color: var(--main-color);
    }

    &:focus {
        color: var(--main-color);
        border-color: #fff;
    }
}
</style>